import React from 'react';
import FullRefundCta from './components/FullRefundCta';
import { refundItemsInfoMap } from '../../utils';
import styles from "../../styles.module.scss";
import { formattedPrice } from '../../../../../../views/pages/manage/unAssigned/collectPayment/utils';


const RefundItems = ({ refundItems, totalAmountToRefund, ...props }) => {

    return (
        <div className='a-card d-flex flex-column m-0' style={{ gap: '1rem' }}>

            <div className='d-flex justify-content-between'>
                <h3>{props?.viewOnly ? 'Refund Items' : 'Choose refund items'}</h3>

                {!props?.viewOnly && !props?.forRefundEdit && <FullRefundCta {...props} />}

            </div>


            {refundItems?.map((item) =>
                React.createElement(refundItemsInfoMap[item]?.component, { key: item, ...props })
            )}

            <div className='d-flex align-items-center'>

                <div className={`${styles['accordion-title']} mr-1`}>Total Refund Amount •</div>
                <div className={`${styles['amount']}`}>{formattedPrice(totalAmountToRefund)}</div>

            </div>

        </div>
    );
}

export default RefundItems;